import { wrapSvg } from '../../../util/SvgImage';

export const Tick = wrapSvg(
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2069 7.70736C17.5972 7.3167 18.2304 7.31647 18.6211 7.70685C19.0117 8.09723 19.012 8.7304 18.6216 9.12106L10.6245 17.124C10.234 17.5147 9.60063 17.5148 9.21 17.1242L5.20711 13.1213C4.81658 12.7308 4.81658 12.0976 5.20711 11.7071C5.59763 11.3166 6.2308 11.3166 6.62132 11.7071L9.91685 15.0026L17.2069 7.70736Z"
      fill="currentColor"
    />
  </svg>,
);
